module.exports = {"data":{"site":{"siteMetadata":{"facebook":{"appId":"coralpiyu"}}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 787
// module chunks = 142629428675168